
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDTb7Ro_B57NJ_mlOHOUW67QMwrPW9F2No",
  authDomain: "group-chat-honex.firebaseapp.com",
  projectId: "group-chat-honex",
  storageBucket: "group-chat-honex.appspot.com",
  messagingSenderId: "605058393278",
  appId: "1:605058393278:web:ed9798f8cc5680bd7beaef"
};


export const app = initializeApp(firebaseConfig);